import {
  ThumbsUp,
  ThumbsDown,
  CircleHelp,
  Ban,
  Globe,
  Users,
  Heart,
  type LucideIcon,
} from "lucide-react-native";

// ============================================================================
// Ancestry / Ethnicity  (API enum values)
// ============================================================================

export type AncestryEnum =
  | "african"
  | "african_or_african_american"
  | "middle_eastern_north_african"
  | "american_indian_native_american"
  | "caucasian"
  | "asian"
  | "hispanic_caribbean"
  | "multi_racial"
  | "other"
  | "i_dont_know"; // "Prefer not to say" maps to this

export const ANCESTRY_OPTIONS: {
  id: AncestryEnum;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "african",
    labelKey: "med_history.family_history.ancestry.african",
    icon: Users,
  },
  {
    id: "african_or_african_american",
    labelKey: "med_history.family_history.ancestry.african_or_african_american",
    icon: Users,
  },
  {
    id: "middle_eastern_north_african",
    labelKey:
      "med_history.family_history.ancestry.middle_eastern_north_african",
    icon: Users,
  },
  {
    id: "american_indian_native_american",
    labelKey:
      "med_history.family_history.ancestry.american_indian_native_american",
    icon: Users,
  },
  {
    id: "caucasian",
    labelKey: "med_history.family_history.ancestry.caucasian",
    icon: Users,
  },
  {
    id: "asian",
    labelKey: "med_history.family_history.ancestry.asian",
    icon: Users,
  },
  {
    id: "hispanic_caribbean",
    labelKey: "med_history.family_history.ancestry.hispanic_caribbean",
    icon: Users,
  },
  {
    id: "multi_racial",
    labelKey: "med_history.family_history.ancestry.multi_racial",
    icon: Globe,
  },
  {
    id: "other",
    labelKey: "med_history.family_history.ancestry.other",
    icon: Heart,
  },
  {
    id: "i_dont_know",
    labelKey: "med_history.family_history.ancestry.i_dont_know",
    icon: Ban,
  },
];

// ============================================================================
// Adoption Status
// ============================================================================

export type AdoptionStatusEnum =
  | "adopted_or_dont_know_biological_parents"
  | "from_gamete_donation"
  | "not_adopted";

export const ADOPTION_OPTIONS: {
  id: AdoptionStatusEnum;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "adopted_or_dont_know_biological_parents",
    labelKey:
      "med_history.family_history.adoption.adopted_or_dont_know_biological_parents",
    icon: Users,
  },
  {
    id: "from_gamete_donation",
    labelKey: "med_history.family_history.adoption.from_gamete_donation",
    icon: Heart,
  },
  {
    id: "not_adopted",
    labelKey: "med_history.family_history.adoption.not_adopted",
    icon: Ban,
  },
];

// ============================================================================
// Family Members (API enum values)
// ============================================================================

export type FamilyMemberEnum =
  | "mother"
  | "father"
  | "brother"
  | "sister"
  | "grandmother_mother_side"
  | "grandfather_mother_side"
  | "grandmother_father_side"
  | "grandfather_father_side"
  | "other";

export const FAMILY_MEMBER_OPTIONS: {
  id: FamilyMemberEnum;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  {
    id: "mother",
    labelKey: "med_history.family_history.family_member.mother",
    icon: Users,
  },
  {
    id: "father",
    labelKey: "med_history.family_history.family_member.father",
    icon: Users,
  },
  {
    id: "brother",
    labelKey: "med_history.family_history.family_member.brother",
    icon: Users,
  },
  {
    id: "sister",
    labelKey: "med_history.family_history.family_member.sister",
    icon: Users,
  },
  {
    id: "grandmother_mother_side",
    labelKey:
      "med_history.family_history.family_member.grandmother_mother_side",
    icon: Users,
  },
  {
    id: "grandfather_mother_side",
    labelKey:
      "med_history.family_history.family_member.grandfather_mother_side",
    icon: Users,
  },
  {
    id: "grandmother_father_side",
    labelKey:
      "med_history.family_history.family_member.grandmother_father_side",
    icon: Users,
  },
  {
    id: "grandfather_father_side",
    labelKey:
      "med_history.family_history.family_member.grandfather_father_side",
    icon: Users,
  },
  {
    id: "other",
    labelKey: "med_history.family_history.family_member.other",
    icon: Heart,
  },
];

// ============================================================================
// Yes / No / I don't know
// ============================================================================

export type YesNoUnknown = "yes" | "no" | "unknown";

export const YES_NO_OPTIONS: {
  id: "yes" | "no";
  labelKey: string;
  icon: LucideIcon;
}[] = [
  { id: "yes", labelKey: "med_history.shared.yes", icon: ThumbsUp },
  { id: "no", labelKey: "med_history.shared.no", icon: ThumbsDown },
];

export const YES_NO_UNKNOWN_OPTIONS: {
  id: YesNoUnknown;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  { id: "yes", labelKey: "med_history.shared.yes", icon: ThumbsUp },
  { id: "no", labelKey: "med_history.shared.no", icon: ThumbsDown },
  { id: "unknown", labelKey: "med_history.shared.unknown", icon: CircleHelp },
];
